import { apiCall } from "./data";

export const loginUser = async (data) => {
    return apiCall("api/user/UserLogin", "POST", data);
};

export const signupUser = async (data) => {
    return apiCall("api/user/UserSignUp", "POST", data);
};
